<template>
  <el-card
    class="background"
    v-loading="loading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <el-card>
      <div slot="header" class="title">
        <span>基础信息</span>
      </div>
      <SiruiSearch
        :query="baseInfoData"
        :columns="formColumn"
        :isQueryPanel="false"
        :isDisabledForm="true"
      ></SiruiSearch>
    </el-card>
    <el-card style="margin-top: 20px">
      <div slot="header" class="title">
        <span>结算信息</span>
      </div>
      <el-table :data="tableData">
        <el-table-column label="序号" type="index" width="120"></el-table-column>
        <el-table-column label="合同编号" prop="contractNo">
          <template slot-scope="scope">
            <div @click="handleContractDetail(scope.row)" class="contractNo-style">
              <span>{{ scope.row.contractNo }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="租金" prop="rentAmount"></el-table-column>
        <el-table-column label="佣金结算总额(元)" prop="commissionTotalAmount"></el-table-column>
        <el-table-column label="佣金结算">
          <el-table-column label="姓名" prop="userName"></el-table-column>
          <el-table-column label="角色" prop="roleName"></el-table-column>
          <el-table-column label="佣金金额" prop="commissionAmount"></el-table-column>
          <el-table-column label="结算金额" prop="settlementAmount"></el-table-column>
        </el-table-column>
      </el-table>
    </el-card>
    <el-card style="margin-top: 20px" v-if="operateType !== 'detail'">
      <div slot="header" class="title">
        <span>审批信息</span>
      </div>
      <el-form :model="auditInfo" :rules="rules" label-width="80px" label-position="right">
        <el-form-item label="审批信息" prop="info">
          <el-input
            v-model="auditInfo.info"
            placeholder="请输入"
            clearable
            minlength="2"
            maxlength="50"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 20px" v-if="operateType === 'detail'">
      <div slot="header" class="title">
        <span>审核记录</span>
      </div>
      <sirui-table
        ref="siruiTable"
        :data="auditRecordData"
        :paging="false"
        :setting="false"
        :customVisible="false"
        :columns="searchColumn"
        :height="300"
      >
        <!-- <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column> -->
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in searchColumn"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
        </vxe-table-column>
      </sirui-table>
    </el-card>
    <div class="btns">
      <el-button type="primary" @click="approval" v-if="operateType !== 'detail'">通过</el-button>
      <el-button type="primary" @click="reject" v-if="operateType !== 'detail'">驳回</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </el-card>
</template>

<script>
  import API from '@/api/property/reward';
  import XEUtils from 'xe-utils';
  import { auditStatusList, settlementStatusList } from '../data';
  export default {
    name: 'RewardDetail',
    mounted() {
      this.id = this.$route.query.id;
      if (this.id) {
        this.getRewardDetail(this.id);
      }
    },
    data() {
      return {
        loading: false,
        baseInfoData: {
          nicheCompanyName: '',
          nicheDepartmentName: '',
          rewardSettlementNo: '',
          nicheNo: '',
          contractNo: '',
          customerName: '',
          rentAmount: '',
          commissionTotalAmount: '',
          createPersonName: '',
          gmtCreate: '',
          settlementStatus: '',
          auditStatus: '',
        },
        auditInfo: {
          info: '',
        },
        rules: {
          info: [{ required: true, message: '请填写审核信息', trigger: ['blur', 'change'] }],
        },
        tableData: [],
        contractId: '',
        auditRecordData: [],
        searchColumn: [
          {
            field: 'optUserName',
            title: '操作人',
            visible: true,
          },
          {
            field: 'optType',
            title: '操作',
            visible: true,
          },
          {
            field: 'optTime',
            title: '操作时间',
            visible: true,
          },
          {
            field: 'info',
            title: '审批信息',
            visible: true,
          },
        ],
        auditStatusList,
        settlementStatusList,
        settlementStatus: '',
      };
    },
    computed: {
      formColumn() {
        return [
          {
            prop: 'nicheCompanyName',
            name: '公司',
            type: 'input',
            span: 8,
          },
          {
            prop: 'nicheDepartmentName',
            name: '部门',
            type: 'input',
            span: 8,
          },
          {
            prop: 'rewardSettlementNo',
            name: '结算编号',
            type: 'input',
            span: 8,
          },
          {
            prop: 'nicheNo',
            name: '招商编号',
            type: 'input',
            span: 8,
          },
          {
            prop: 'contractNo',
            name: '合同编号',
            type: 'input',
            span: 8,
          },
          {
            prop: 'customerName',
            name: '客户名称',
            type: 'input',
            span: 8,
          },
          {
            prop: 'rentAmount',
            name: '租金',
            type: 'input',
            span: 8,
          },
          {
            prop: 'commissionTotalAmount',
            name: '佣金总额',
            type: 'input',
            span: 8,
          },
          {
            prop: 'auditStatus',
            name: '审核状态',
            type: 'input',
            span: 8,
          },
          {
            prop: 'createPersonName',
            name: '申请人',
            type: 'input',
            span: 8,
          },
          {
            prop: 'settlementStatus',
            name: '结算状态',
            type: 'input',
            span: 8,
          },
          {
            prop: 'gmtCreate',
            name: '申请时间',
            type: 'input',
            span: 8,
          },
        ];
      },
      operateType() {
        return this.$route.query.type;
      },
    },
    methods: {
      getRewardDetail(id) {
        this.$axios.get(API.REWARD_DETAIL + '/' + id).then((res) => {
          if (res.data.code === 0) {
            const data = res.data.data || {};
            this.contractId = data.contractId;
            this.settlementStatus = data.settlementStatus;
            const baseInfo = {
              nicheCompanyName: data.nicheCompanyName || 'nicheCompanyName',
              nicheDepartmentName: data.nicheDepartmentName || 'nicheDepartmentName',
              rewardSettlementNo: data.rewardSettlementNo || 'rewardSettlementNo',
              nicheNo: data.nicheNo || 'nicheNo',
              contractNo: data.contractNo || 'contractNo',
              customerName: data.customerName || 'customerName',
              rentAmount: data.rentAmount || 'rentAmount',
              commissionTotalAmount: data.commissionTotalAmount || 'commissionTotalAmount',
              createPersonName: data.createPersonName || 'createPersonName',
              gmtCreate: data.gmtCreate || 'gmtCreate',
              auditStatus: this.transferSelect(data.auditStatus, this.auditStatusList),
              settlementStatus: this.transferSelect(
                data.settlementStatus,
                this.settlementStatusList
              ),
            };
            Object.assign(this.baseInfoData, baseInfo);
            this.tableData = data.nicheRewardSettlementLines || [];
            this.tableData.forEach((item) => {
              item.contractNo = data.contractNo;
              item.rentAmount = data.rentAmount;
              item.commissionTotalAmount = data.commissionTotalAmount;
              item.settlementAmount = this.settlementStatus === '02' ? item.settlementAmount : '';
            });
            this.auditRecordData = data.nicheRewardSettlementAuditRecords || [];
          }
        });
      },
      cancel() {
        this.returnPath();
      },
      approval() {
        console.log('approval');
        if (!this.auditInfo.info || this.auditInfo.info.length < 2) {
          return this.$message({
            showClose: true,
            message: '请填写审批意见',
            type: 'error',
          });
        }
        this.$axios
          .post(`${API.REWARD_AUDIT}/${this.id}/pass?info=${this.auditInfo.info}`)
          .then((res) => {
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: '操作成功',
                type: 'success',
              });
              this.returnPath();
            }
          });
      },
      reject() {
        console.log('reject');
        if (!this.auditInfo.info) {
          return this.$message({
            showClose: true,
            message: '请填写审批意见',
            type: 'error',
          });
        }
        this.$axios
          .post(`${API.REWARD_AUDIT}/${this.id}/reject?info=${this.auditInfo.info}`)
          .then((res) => {
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: '操作成功',
                type: 'success',
              });
              this.returnPath();
            }
          });
      },
      returnPath() {
        // 返回列表页
        let path = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: { keepAlive: true },
          },
          toPath: {
            path: '/reward/overview',
            name: 'rewardOverview',
            meta: { keepAlive: false },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      handleContractDetail(row) {
        console.log(row, '跳转合同详情');
        const path = {
          path: 'propert/detailLeaseContract',
          name: 'detailLeaseContract',
          meta: {
            keepAlive: true,
            title: '租赁合同详情',
          },
          query: {
            type: 'detail',
            contractId: this.contractId,
          },
        };
        this.$router.push(path);
      },
      transferSelect(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .title {
    font-size: 20px;
    font-weight: 600;
  }
  .btns {
    margin-top: 20px;
  }
  ::v-deep .el-table .cell {
    text-align: center;
  }
  .contractNo-style {
    cursor: pointer;
    color: blue;
  }
</style>
